import { useEffect } from "react";

/**
 * Set the document title with a consistent Encamp prefix.
 * Pass undefined to do nothing (useful when another provider controls the title).
 */
export function usePageTitle(title?: string) {
  useEffect(() => {
    if (title == null) return;
    const base = "Encamp";
    document.title = title ? `${base} / ${title}` : base;
  }, [title]);
}
